"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var W9Resource = /** @class */ (function (_super) {
    tslib_1.__extends(W9Resource, _super);
    function W9Resource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    W9Resource.endpoint = '/formw9s';
    W9Resource.MODEL_NAME = 'formw9';
    return W9Resource;
}(base_1.default));
exports.default = W9Resource;
//# sourceMappingURL=w9.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/w9.js
// module id = P+ip
// module chunks = 0